import { createRoot } from 'react-dom/client';
import { StaticLandingApp } from './static-landing-app';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);
root.render(<StaticLandingApp />);